import { dto_Customer } from "../classes/dto-customer";
import { ENCRYPT_STORAGE } from "../config/config";
import { api_SaveNIC, api_UpdateExpoPushToken } from "../connection/api/api-profile";
import { STORE_CSID, STORE_NIC } from "../database/store-names";
import { GENERATE_NIC } from "./funtion";

export const CHECK_NIC = async () => {
  let CSID = ENCRYPT_STORAGE.getItem(STORE_CSID);
  let ST_NIC = ENCRYPT_STORAGE.getItem(STORE_NIC);

  if (CSID === undefined || 0 === parseInt(CSID)) {
    if (
      ST_NIC === undefined ||
      ST_NIC === 0 ||
      ST_NIC === "0" ||
      ST_NIC === ""
    ) {
      let NIC = await GENERATE_NIC();
      let RsNIC = JSON.parse(NIC);
      dto_Customer.NIC = RsNIC.NIC;
      ENCRYPT_STORAGE.setItem(STORE_NIC, RsNIC.NIC);
    } else {
      dto_Customer.NIC = ST_NIC;
    }
  } else {
    dto_Customer.CSID = CSID;
    return;
  }
};
export const UPDATE_MOBILE_PUSH_TOKEN = async () => {
  if (
    dto_Customer.PushToken === undefined ||
    dto_Customer.PushToken === "0" ||
    dto_Customer.PushToken === 0 ||
    dto_Customer.PushToken === ""
  ) {
    return;
  } else {
    await api_UpdateExpoPushToken();
  }
};
export const SAVE_NIC = async () => {
  if (
    dto_Customer.NIC !== 0 &&
    dto_Customer.NIC !== "" &&
    dto_Customer.NIC !== "0" &&
    dto_Customer.NIC !== undefined &&
    dto_Customer.PushToken !== undefined &&
    dto_Customer.PushToken !== "0" &&
    dto_Customer.PushToken !== 0 &&
    dto_Customer.PushToken !== ""
  ) {
    await api_SaveNIC();
  }
};
//#endregion
